import { cn } from '@/lib/utils';

interface LoginNameTagProps {
  loginname: string | null | undefined;
  className?: string;
}

const VALID_LOGINNAME_REGEX = /^[a-z0-9][a-z0-9_.]+[a-z0-9]+$/;

export function LoginNameTag({ loginname, className }: LoginNameTagProps) {
  if (!loginname) {
    return (
      <span className={cn('text-muted-foreground', className)}>no login</span>
    );
  }
  const isValid = VALID_LOGINNAME_REGEX.test(loginname);
  return (
    <span
      className={cn(
        'rounded px-1',
        isValid
          ? 'bg-blue-50 text-blue-600 dark:bg-blue-950/50 dark:text-blue-300'
          : 'bg-red-50 text-red-600 dark:bg-red-950/50 dark:text-red-300',
        className,
      )}
    >
      @{loginname}
    </span>
  );
}
